import CircularProgress from "@mui/material/CircularProgress";
import { fontSizes } from "healthex-common/sizes";
import { colors } from "healthex-common/colors";
import { fontWeights } from "healthex-common/weights";
import React from "react";
import styled from "styled-components";
import { FlexColumn } from "./common.styles";
import { HXMobileButton } from "./HXButton";
import { AnchorBlue, ContentContainer as HXContentContainer, MailtoLink, Subtitle as HXSubtitle, TinyText, LighterText, } from "./HXMobilePage.styles";
export const ContentContainer = styled(HXContentContainer).attrs({ horizontalPadding: 16 }) `
    gap: 24px;
    padding-bottom: 24px;
`;
export const MediumSubtitle = styled(HXSubtitle) `
    font-size: ${fontSizes.MEDIUM};
`;
export const ConsentButton = styled(HXMobileButton) `
    border-color: ${colors.tulip_main};
    color: ${colors.tulip_main};
`;
export const ProofOfConsentDownloadContainer = styled(FlexColumn) `
    gap: 8px;
`;
const ProofOfConsentCircularProgress = styled(CircularProgress) `
    color: ${colors.black_30};
    width: 16px !important;
    height: 16px !important;
    margin-right: 4px;
`;
const ProofOfConsentCircularProgressBlack = styled(CircularProgress) `
    color: ${colors.black_main};
    width: 16px !important;
    height: 16px !important;
    margin-right: 4px;
`;
export const DownloadProofOfConsentButton = styled(HXMobileButton).attrs({
    variant: "outlined",
}) ``;
export const DownloadProofOfConsentLoadingButton = styled(HXMobileButton).attrs({
    startIcon: React.createElement(ProofOfConsentCircularProgress),
}) ``;
export const DownloadProofOfConsentOpeningButton = styled(HXMobileButton).attrs({
    variant: "outlined",
    startIcon: React.createElement(ProofOfConsentCircularProgressBlack),
}) ``;
export const ProofOfConsentStatusText = styled(TinyText) `
    color: ${(props) => (props.isError ? colors.tulip_main : colors.black_lighter)};
`;
export const ProofOfConsentStatusEmail = styled(MailtoLink) `
    color: ${colors.tulip_main};
    font-size: ${fontSizes.TINY};
    font-weight: ${fontWeights.NORMAL};
    letter-spacing: 0.4px;
`;
export const ProofOfConsentStatusExternalLink = styled.a `
    color: ${colors.tulip_main};
    font-size: ${fontSizes.TINY};
    font-weight: ${fontWeights.NORMAL};
    letter-spacing: 0.4px;
    text-decoration: underline;
`;
const PatientStudyContactLink = styled(AnchorBlue) `
    font-size: inherit;
    font-weight: inherit;
    line-height: inherit;
    letter-spacing: inherit;
    overflow-wrap: break-word;
`;
export const PatientStudyContactMailtoLink = PatientStudyContactLink;
export const PatientStudyContactExternalLink = PatientStudyContactLink;
export const PatientDetailsOrgBannerCircularContainer = styled.div `
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 32px 24px;
    overflow: hidden;
    background: ${colors.history_surface_bg};
    border-bottom: 1px solid ${colors.separator_main};
    margin: 0 -16px 0;
    align-self: stretch;
`;
export const PatientDetailsOrgBannerCircularImg = styled.img `
    position: relative;
    max-width: 100%;
    height: 120px;
    object-fit: contain;
`;
export const PatientDetailsOrgBannerRectangularContainer = styled.div `
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    background: ${colors.history_surface_bg};
    border-bottom: 1px solid ${colors.separator_main};
    margin: 0 -16px 0;
    align-self: stretch;
    width: calc(100% + 32px);
    height: auto;
    aspect-ratio: 402 / 185;
`;
export const PatientDetailsOrgBannerRectangularImg = styled.img `
    position: relative;
    max-width: 100%;
    min-height: 100%;
    object-fit: contain;
`;
export const PatientStatusDescriptionText = styled(LighterText) `
    line-height: 24px;
    letter-spacing: -0.31px;
`;
